export const getPlannedVacationDatesArr = (defaultValues) =>{
    defaultValues.plannedVacationDatesArr = [new Date(defaultValues.dateFrom),new Date(defaultValues.dateTo)]
} 